<template>
   <div id="idAgregarClienteTerrestreModal">
        <Button
            :size="15"
            color="#2da44e"
            colorText="#ffffff"
            tooltip="Agregar proveedor"
            icon="fas fa-plus"
            round
            :width="30"
            class="mr-2"
            traslate
            @click.native="openModal('modal')"
        />

        <ui-modal 
            ref="modal" 
            title="Agregar Cliente Terrestre"
            transition="scale-up"
            size="large"
            @close="ActionSetZindexTablaModal(false); ActionSetZindexModal(false);"
        >
            <div class="w-100 container-fluid">

                <div class="row w-100">
                    <div class="col">
                        <fieldset-component texto="Datos Tarifa Cliente Terrestre" />
                    </div>
                </div>

                <div class="row w-100 mt-3">
                    <div class="col-4 ">
                        <ui-select
                            class="w-100"
                            label="Clientes (*)"
                            hasSearch
                            searchPlaceholder="Buscar"
                            placeholder="Seleccionar Cliente"
                            :keys="keys"
                            :options="clientsList"
                            v-model="id_client"
                            @change="buscarPlanta(id_client); plantasList=[]; plant_id=[]"
                        />
                    </div>
                </div>

                <div class="row w-100 mt-2">
                    <div class="col-4">
                        <date-picker
                            placeholder="Vigencia (*)"
                            type="date"
                            class="w-100"
                            value-type="format"
                            v-model="vigency"
                        />
                    </div>

                    <div class="col-4">
                        <ui-select
                            class="w-100"
                            label="Tipo contenedor (*)"
                            hasSearch
                            searchPlaceholder="Buscar"
                            placeholder="Seleccionar opción"
                            :keys="keys"
                            :options="containerTypes"
                            v-model="id_container_type"
                        />
                    </div>

                    <div class="col-4">
                        <ui-select
                            class="w-100"
                            label="Tipo Servicio Integral (*)"
                            hasSearch
                            searchPlaceholder="Buscar"
                            placeholder="Seleccionar opción"
                            :keys="keys"
                            :options="integralServiceType"
                            v-model="id_type_service_integral"
                        />
                    </div>
                </div>

                <div class="row w-100 mt-2">
                    <div class="col-4">
                        <ui-select
                            class="w-100"
                            label="Retiro/Entrega (Vacío)"
                            hasSearch
                            searchPlaceholder="Buscar"
                            placeholder="Seleccionar opción"
                            :keys="keys"
                            :options="portsList"
                            v-model="id_pol"
                        />
                    </div>

                    <div class="col-4">
                        <ui-select
                            class="w-100"
                            label="Planta/Bodega (*)"
                            hasSearch
                            searchPlaceholder="Buscar"
                            placeholder="Seleccionar opción"
                            :keys="keys"
                            :options="plantasList"
                            v-model="plant_id"
                        />
                    </div>
                    <div class="col-4">
                        <ui-select
                            class="w-100"
                            label="Entrega/Retiro (Full)"
                            hasSearch
                            searchPlaceholder="Buscar"
                            placeholder="Seleccionar opción"
                            :keys="keys"
                            :options="portsList"
                            v-model="id_pod"
                        />
                    </div>

                </div>
                <div class="row w-100">
                    <div class="col-4">
                        <ui-select
                            class="w-100"
                            label="Extra Costo Tipo (*)"
                            hasSearch
                            searchPlaceholder="Buscar"
                            placeholder="Seleccionar opción"
                            :keys="keys"
                            :options="groundTariffsExtraCostType"
                            v-model="id_extra_costos_tipo"
                        />
                    </div>
                </div>

                <div class="row w-100 mt-2">
                    <div class="col">
                        <Button
                            :width="35"
                            round
                            class="float-left "
                            color="#21831b"
                            colorText="#fff"
                            icon="fas fa-search"
                            title="Buscar"
                            traslate
                            :inactive="btnAction"
                            @click.native="search"
                        />

                        <Button
                            :width="35"
                            round
                            class="float-left ml-2 "
                            color="#21831b"
                            colorText="#fff"
                            icon="far fa-trash-alt"
                            title="Limpiar"
                            traslate
                            :inactive="btnAction"
                            @click.native="clear"
                        />
                    </div>
                </div>

                <div class="row w-100 mt-3">
                    <div class="col">
                        <fieldset-component texto="Resultados Tarifas Extra Costos" />
                    </div>
                </div>

                <div class="row w-100">

                    <div class="col">

                        <div v-if="this.checks.length > 1" style="position: absolute;top:10px;">
                            <span class="text-danger text-bold">Precaución, solo se puede seleccionar un proveedor *</span>
                        </div>

                        <new-data-table
                            check
                            :fila-chekeada="getSelectedRow"
                            :headers="headers"
                            :data="data"
                            :acciones="[]"
                            :max="10"
                            paginacion
                            buscar
                            idtabla="agregar_client_extra_costo_table" 
                        />
                    </div>
                </div>

                <div v-if="checks.length > 0 && checks.length <= 1 && data.length > 0"  class="row w-100">
                    <div class="col">
                        <fieldset-component  class="mt-3" texto="Comentarios Adicionales" />

                    </div>
                </div>
                
                <div class="row w-100 mt-3" v-if="checks.length > 0 && data.length > 0">
                    <div class="col">

                        <textarea 
                            class="form-control w-100"
                            v-model="comments"
                            placeholder="Ingrese Observaciones"
                            type="text"
                            rows="3"
                        />
                    </div>

                </div>

                <div class="row w-100 mt-2" v-if="checks.length > 0 && data.length > 0" >
                    <div class="col">
                        <Button
                            text="Agregar"
                            color="#21831b"
                            :width="100"
                            :height="40"
                            colorText="#fff"
                            class="float-right"
                            icon="far fa-paper-plane"
                            title="Agregar Tarifa Cliente"
                            horizontal
                            @click.native="!btnAction && send()"
                            :inactive="btnAction"
                        />
                    </div>
                </div>
                
            </div>
            
        </ui-modal> 

   </div>

</template>

<script>

    // UI Modal
    import UiModal from "keen-ui/src/UiModal";
    import Button from '@/components/common/Button.vue';
    import FieldsetComponent from '../../../common/FieldsetComponent.vue';
    import NewDataTable from '../../../common/NewDataTable.vue';
    import DatePicker from "vue2-datepicker";
    import { mapActions, mapState } from 'vuex';
    import { getPlantas, tariffClientsGroundIndex, tariffClientsSearch, tariffClientsStorage } from "../../../../constants/serviciosLogisticos";

    export default {

        data(){
            return {
                id_client : {},
                vigency: "",
                keys : { label: 'name', value: 'id' },
                id_container_type : {},
                id_extra_costos_tipo : {} ,
                id_type_service_integral : {},
                id_pod : {},
                id_pol : {},
                plant_id : {},

                data: [],
                checks: [],
                headers: [
                    "ID Tarifa Proveedor",
                    "Desde",
                    "Hasta",
                    "Retiro/Entrega (Vacío)",
                    "Planta/Bodega",
                    "Entrega/Retiro (Full)",
                    "Proveedor",
                    "Tipo Operación",
                    "Tipo Contenedor",
                    "Moneda",
                    "Tipo Extra Costo",
                    "Valor Total",
                    "Observaciones"
                ],
                btnAction: false,

                comments: "",
                plantasList: []

            }
        },

        components: {
            UiModal,
            Button,
            FieldsetComponent,
            NewDataTable,
            DatePicker,
        },
        computed: {
            ...mapState("serviciosLogisticos", [
                "clientsList",
                'containerTypes',
                'integralServiceType',
                'groundTariffsExtraCostType',
                'portsList',
            ]),
        },
        methods : {

            ...mapActions([ "ActionSetZindexTablaModal","ActionSetZindexModal"]),

            ...mapActions("serviciosLogisticos", [
                "actionSetShowLoadingClientGround",
                "actionSetDataTableClientGround"
            ]),

            openModal(ref) {
                this.$refs[ref].open();
                this.ActionSetZindexModal(true);
            },
            
            closeModal(ref) {
                this.$refs[ref].close();
                this.ActionSetZindexTablaModal(false);

            },

            cerrarModal(){
                this.closeModal('modal');
            },

            clear (){
                this.id_client =  {};
                this.vigency = "";
                this.id_container_type =  {};
                this.id_type_service_integral =  {};

                this.id_pol =  {};
                this.id_pod =  {};
                this.plant_id =  {};

                this.data = [];
                this.comments = "";
                this.checks = [];
                this.id_extra_costos_tipo = {};
            },

            valid(){

                if( ! this.id_client.id ){
                    this.$vToastify.warning("Campo 'Cliente (*)' Obligatorio", "Alerta");
                    return false ;
                }

                if( ! this.vigency ){
                    this.$vToastify.warning("Campo 'Vigencia (*)' Obligatorio", "Alerta");
                    return false ;
                } 

                if( ! this.id_container_type.id ){
                    this.$vToastify.warning("Campo 'Tipo Contenedor (*)' Obligatorio", "Alerta");
                    return false ;
                }

                if( ! this.id_type_service_integral.id ){
                    this.$vToastify.warning("Campo 'Tipo Servicio Integral (*)' Obligatorio", "Alerta");
                    return false ;
                }

                if( ! this.plant_id.id ){
                    this.$vToastify.warning("Campo 'Planta/Bodega (*)' Obligatorio", "Alerta");
                    return false ;
                }

                if( ! this.id_extra_costos_tipo.id ){
                    this.$vToastify.warning("Campo 'Extra Costo Tipo (*)' Obligatorio", "Alerta");
                    return false ;
                }



                return true ;
            },
            
            async search(){

                if( ! this.valid() ) return ;

                this.$vToastify.loader("Buscado Proveedores Terrestres...");
                
                const payload = {
                    id_client : this.id_client.id ?? null ,
                    id_container_type : this.id_container_type.id ?? null ,
                    id_type_service_integral : this.id_type_service_integral.id ?? null ,
                    id_extra_cost_type : this.id_extra_costos_tipo.id ?? null ,
                    vigency : !this.vigency ? null : this.vigency ,
                    id_pol  : this.id_pol.id ?? null ,
                    id_pod  : this.id_pod.id ?? null ,
                    plant_id : this.plant_id.id ?? null ,
                };

                try {
                    
                    const { data } = await tariffClientsSearch( payload );

                    if( data.length == 0 ){
                        this.data = [] ;
                        this.$vToastify.stopLoader();
                        return this.$vToastify.warning("No se Encontraron Tarifas Terrestres.", "Alerta");
                    }

                    this.data = this.formatData( data );

                    this.$vToastify.stopLoader();

                } catch (error) {
                    this.data = [] ;
                    this.$vToastify.stopLoader();
                    return this.$vToastify.error("No se Encontraron Tarifas Terrestres.", "Error");
                }
            },

            async send(){
                
                if( this.checks.length == 0 ) return this.$vToastify.warning( "Debe Seleccionar Tarifa", "Alerta");

                if( this.checks.length > 1 ) return this.$vToastify.warning( "Solo se puede Seleccionar una Tarifa", "¡Precaución!");
                            
                
                const data = this.checks.map( c => this.data[c] ) ;

                const payload = data.map( ({ data_complementaria }) => ({
                    id_tariff_provider_ground : data_complementaria.id ?? null,
                    id_client : this.id_client.id ?? null,
                    value : data_complementaria.value ?? null,
                    id_type_extra_cost : data_complementaria.extraCostType.id ?? null,
                    id_tier : data_complementaria.tier.id ?? null,
                    comment : !this.comments ? null : this.comments,
                }));

                this.$vToastify.loader("Agregando Tarifa Clientes Terrestres...");

                this.btnAction = true ;

                try {
                    
                    await tariffClientsStorage( payload );

                    this.$vToastify.stopLoader();

                    this.$vToastify.success("Se ha agregado tarifa correctamente", "Éxito");

                    this.clear() ;

                    this.btnAction = false ;

                    this.rechargeTable() ;

                    return this.cerrarModal() ;

                } catch (error) {

                    this.btnAction = false ;

                    this.$vToastify.stopLoader();

                    return this.$vToastify.error("No se Encontraron Tarifas para Proveedores Extra Costo.", "Error");
                }
                
            },

            async rechargeTable(){
         
                this.actionSetShowLoadingClientGround( true );

                const { data } = await tariffClientsGroundIndex() ;

                this.actionSetDataTableClientGround( data ) ;

                this.actionSetShowLoadingClientGround( false );
            },

            formatData( data ){
                return data.map( d => ({
                    data : [
                        d.id,
                        d.from,
                        d.to ,
                        d.name_pol ,
                        d.name_plant ,
                        d.name_pod ,
                        d.name_carrier,
                        d.code_service_types,
                        d.name_type_container,
                        d.code_currency,
                        d.extraCostType.nombre ,
                        d.value,
                        d.comments
                    ],
                    data_complementaria: d
                })) ;
            },

            async getSelectedRow({ id , estado, accion }) {

                switch ( accion ) {
                    
                    case "fila_chekeada": {

                        estado 
                        ? this.checks.push( id )
                        : this.checks = this.checks.filter( c => c != id ) ;

                    }
                    break ;
                }
            },

            async buscarPlanta({id}){

                this.plantasList = await getPlantas(id);

            }

        }

    }

</script>

<style>

#idAgregarClienteTerrestreModal .mx-input {
    padding-left: 2px !important;
    border-radius: 0 !important;
    border: none !important;
    border-bottom: 1px solid #dcdcdc !important;
    box-shadow: none !important;
    margin-top: 18.2px;
}


#idAgregarClienteTerrestreModal .ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
    width: 75% !important;
 }
</style>